export enum DoctorRegisterStatus {
  UNREVIEWED_REGISTER = 'UNREVIEWED_REGISTER',
  PENDENT = 'PENDENT',
  REVIEWED_BY_DIRECTOR = 'REVIEWED_BY_DIRECTOR',
  APPROVED_BY_DIRECTOR_WITH_PENDENCIES = 'APPROVED_BY_DIRECTOR_WITH_PENDENCIES',
  PENDENCY_ANSWERED = 'PENDENCY_ANSWERED',
  REGISTER_SEND_TO_DIRECTOR = 'REGISTER_SEND_TO_DIRECTOR',
  REGISTER_RESEND_TO_DIRECTOR = 'REGISTER_RESEND_TO_DIRECTOR',
  REGISTER_CONCLUDED = 'REGISTER_CONCLUDED',
  REGISTER_REPROVED_BY_DIRECTOR = 'REGISTER_REPROVED_BY_DIRECTOR',
  INCOMPLETE_REGISTER = 'INCOMPLETE_REGISTER'
}
